import { normalizePhoneE164 } from './phoneAddresses.js';

export const RETIRED_SMS_LINE = '+13072882778';
// Shared by the browser and Edge Functions. Array/query order never chooses the main line.
export function resolveMainSmsLine(numbers = [], savedMainLine = '') {
    const saved = normalizePhoneE164(savedMainLine);
    if (/^\+[1-9]\d{7,14}$/.test(saved) && saved !== RETIRED_SMS_LINE) return saved;
    return [...(Array.isArray(numbers) ? numbers : [])]
        .filter((row) => row.sms_enabled === true && !row.blockedReason
            && /^\+[1-9]\d{7,14}$/.test(normalizePhoneE164(row.phone_number || row.address))
            && normalizePhoneE164(row.phone_number || row.address) !== RETIRED_SMS_LINE)
        .sort((a, b) => String(a.created_at || '').localeCompare(String(b.created_at || ''))
            || String(a.phone_number || a.address).localeCompare(String(b.phone_number || b.address)))
        .map((row) => normalizePhoneE164(row.phone_number || row.address))[0] || '';
}
